import React from "react";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ userType, children }) {
  const cookies = new Cookies(null, { path: "/" });
  let userCookieName;

  switch (userType) {
    case "pravno":
      userCookieName = "pravnoLice";
      break;
    case "fizicko":
      userCookieName = "fizickoLice";
      break;
    default:
      userCookieName = "user";
  }

  const user = cookies.get(userCookieName);

  if (!user) {
    return <Navigate to="/error/401" replace />;
  }

  return children;
}

export default ProtectedRoute;
